export const FooterText = () => {
  const year = new Date().getFullYear();

  return (
    <p>© {year} Sistema Cartão Cria. Todos os direitos reservados.</p>
  );
}
